export class LoginSettings {
    Id: number;
    DistrictLogo: number[];
    CountryCode: string;
    AttemptsAllowed: number;
    FreezeTime: number;
    EnablePasswordComplexity: boolean;
    MinimumLength: number;
    PasswordExpirationInterval: number;
    PreventPasswordReuse: boolean;
    PreventEqualPassUserName: boolean;
    PasswordRequiresUpper: boolean;
    PasswordRequiresNumeric: boolean;
    PasswordRequiresSpecial: boolean;
    DisplayDistrictNameOnLoginPage: number;
    DisplayClassMeetsOnStudentScheduleCard: boolean;
    DisplayForgotUserName: boolean;
    DisplayForgotPassword: boolean;
    DisplaySeparateUserTypes: boolean;
    ParentPortalDisciplineShowComments: boolean;
    ParentPortalCourseScheduleProfiles: boolean;
    ParentPortalAssignmentsDisplayProfiles: boolean;
    ParentPortalAssignmentsShowEffectiveScore: boolean;
    ParentPortalAssignmentsShowGradeColumn: boolean;
    ParentPortalAttendanceCommentsByPeriod: boolean;
    ParentPortalStudentSubjectDelStatus: boolean;
    ParentPortalNotificationSettingsByStudent: boolean;
    ParentPortalNotificationSettingsSelectFrequency: boolean;
    ParentPortalHealthShowMedicineFrequency: boolean;
    ParentPortalHealthShowDoctorAddress: boolean;
    ParentPortalHealthShowDoctorEmail: boolean;
    ParentPortalReportCardGradesShowCitizenship: boolean;
    StudentUserNameLabel: string;
    NumberOfFailedAttemptsPriorToLockout: number;
    DistrictName: string;
    DistrictSpanishName: string;
    DistrictFrenchName: string;
    DistrictURL: string;
    DistrictLoginMessage: string;
    LoginAssistMessage: string;
    TimeoutTime: number;
    DisplayCustodyIssue: boolean;
    DisplayBus: boolean;
    DisplayReportCardTranscriptOnHold: boolean;
    DisplayEmergencyPhoneNumberInGrid: boolean;
    DisplayIsGuardian: boolean;
    DisplayCanPickup: boolean;
    DisplayHasCustody: boolean;
    ParentPortalORShowAttachments: boolean;
    ParentPortalORv10Data: boolean;
    ParentPortalORCustomFormWidth: number;
    ParentPortalUHDv10Data: boolean;
    ParentPortalCourseRequestsShowRequirements: boolean;
    ParentPortalShowStudentTeams: boolean;
    ParentPortalAssessmentsShowBestOf: boolean;
    ParentPortalShowMonthlyLunchMeal: boolean;
    DisplayChangeEmailAddress: boolean;
    PasswordCaseSensitive: boolean;
    DisplayProgressGradesCheckBox: boolean;
    ParentPortalShowAttendExcessiveTab: boolean;
    ParentPortalShowAttendSpecialTab: boolean;
    Student360StaffLoginChangeUserName: boolean;
    MinimumPasswordLength: number;
    PasswordRequiresMixedLettersAndNumbers: boolean;
    Student360StaffPasswordCaseSensitive: boolean;
    Classroom360AttendanceDateAllowEditing: boolean;
    Classroom360AttendanceAllowMerging: boolean;
    Classroom360AttendanceSeatingChartView: boolean;
    Classroom360AttendanceLunchCountAdults: boolean;
    Classroom360AttendanceAllPeriods: boolean;
    Classroom360AttendancePerfectOverwrites: boolean;
    Classroom360AttendanceCommentsEditable: boolean;
    Classroom360AttendanceShowTardyTime: boolean;
    OneSISVersion: string;
    MyClassesShowView: boolean;
    ParentPortalShowParentTab: boolean;
    ParentPortalShowStudentTab: boolean;
    ParentPortalShowOnlinePayment: boolean;
    ParentPortalShowParentStudentLinks: boolean;
    C360ShowCommunicationLog: boolean;
    ActivateStudent360: boolean;
    ActivateClassroom360: boolean;
    StaffUserUseADPassword: boolean;
    StudentUserUseADPassword: boolean;
    ActiveDirectoryAgentURL: string;
    C360GradebookGradingPeriod: boolean;
    C360GradebookAllowMerging: boolean;
    C360GradebookUnits: boolean;
    C360GradebookAllowCategoryEditing: boolean;
    C360GradebookCourseSpecificCategories: boolean;
    C360GradebookUseCategoryCodes: boolean;
    C360GradebookAssignmentsLongSummary: boolean;
    C360GradebookAssignmentsGPSpecific: boolean;
    C360GradebookUseStandards: boolean;
    C360GradebookRequireDateAssigned: boolean;
    C360GradebookLimitTo100: boolean;
    C360GradebookWeightIsPercent: boolean;
    C360GradebookAssignmentForSelectedStudents: boolean;
    C360GradebookExcludeAssignmentsFromCalculations: boolean;
    C360GradebookAssignmentAttachmentDescriptions: boolean;
    C360GradebookSGGradesAsAssignments: boolean;
    C360GradebookUseSpecialMarks: boolean;
    C360GradebookSpecialGradingScaleForStudent: boolean;
    C360GradebookUserDefinedScorePrecision: boolean;
    C360GradebookModifyScoresWhenCopying: boolean;
    C360GradebookGradingScalesAllowNumbers: boolean;
    C360GradebookSpecialMarksEditable: boolean;
    C360GradebookAllowTeacherComments: boolean;
    C360GradebookSpanishComments: boolean;
    C360GradebookAllowCustomAssignmentComments: boolean;
    ShowForgotPasswordLink: boolean;
    TabSpecificForgotPasswordLink: boolean;
    ShowForgotUserNameLink: boolean;
    ShowLoginAssistanceInfo: boolean;
    V10: boolean;
    Classroom360AttendanceChangeAll: boolean;
    C360DisciplineReferralsv10PBIS: boolean;
    C360DisciplineReferralsv10PBISClassroom: boolean;
    AllowStudentsToChangeTheirPassword: boolean;
    LegacyURL: string;
    RedirectTeachersTo360: boolean;
    UseUnifiedLoginPage: boolean;
    AllowNewFamiliesToSelfRegister: boolean;
    AllowExistingFamiliesToAddNewStudentsInOR: boolean;
    AllowExistingFamiliesToAddNewStudentsInUHHD: boolean;
    S360HealthShowScreenings: boolean;
    S360DisplayImmunizations: boolean;
    S360DisplayMedications: boolean;
    S360DisplayHealthVisitLog: boolean;
    S360DisplayDoctors: boolean;
    S360DisplayInsurane: boolean;
    S360DisplayScreenings: boolean;
    AllowParentStudentEmail: boolean;
    InstanceName: string;
    DisplayFullBulletins: boolean;
    UseDisciplineEventModel: boolean;
    C360DataQueryAllowEditing: boolean;
    AddReferralsForAllStudents: boolean;
    UsernamePasswordRequestEmail: string;
    UsernamePasswordRequestPhone: string;
    MassEmailContactsGrouped: boolean;
    DefaultEmailReplyToAddress: string;
    UtilizeDistributebyEmail: boolean;
    TeachersMustMarkAttendanceForProjectedStudent: boolean;
    PresentAttendanceCode: string;
    ImportGradeBookFromCanvas: boolean;
    ScoreStandardsByAssignment: boolean;
    LegacyVersion: string;
    ReportsVersion: string;
    StudentNotes: boolean;
    AllowSpanishLanguageMailings: boolean;
    DisableAllEmail: boolean;
    AllowAutoRunReport: boolean;
    MaxReportSnapshotAllowed: number;
    EnablePulseSSO: boolean;
    PulseURL: string;
    DisplayGoogleClassroom: boolean;
    TraversaEnabled: boolean;
    VersatransEnabled: boolean;
    AllowGALDSStudentPortal: boolean;
    AllowGALDSParentPortal: boolean;
    GALDSServiceURL: string;
    DisplaySchoology: boolean;
    ShowTraversaBusNumber: boolean;
    ShowTraversaBusRoute: boolean;
    ActivateDisciplineTeams: boolean;
    TryNewApplication: boolean;
    State: string;
    ReportDefinitionsOption: number;
    AllowArchiveReportPDF: boolean;
    UtilizeTranscriptTracking: boolean;
    BlockClassroom360: boolean;
    AllowFutureFeeBillingPayments: boolean;
    ActivateApplicationMonitoring: boolean;
    EFormUseRoles: boolean;
    EFormNonResident: boolean;
    ActivateBehavior360: boolean;
    ActivateEForms: boolean;
    MailServer: string;
    GoogleAuthentication: boolean;
    GoogleClientId: string;
    DisplayItsLearning: boolean;
    SDMIntegration: boolean;
    ActivateBroadcast: boolean;
    BroadcastInterval: number;
    ForceNewApplication: boolean;
    ForceNewApplicationPS: boolean;
    CreateServiceActivityForHonorRoll: boolean;
    HonorRollProgramID: number;
    ViewDailyAttendance: boolean;
    CreditDecimalPlaces: number;
    ActivateGoogleAuthenticationForStaff: boolean;
    ActivateGoogleAuthenticationForStudent: boolean;
    CustomizationDevMode: boolean;
    ActivateRegistrationEnrollment360: boolean;
    ActivateAttendanceAdministration360: boolean;
    ActivateNotificationFramework360: boolean;
    ActivateGlobalSearch360: boolean;
    S360HideAttendanceComments: boolean;
    BehaviorLetterDocumentType: string;
    ActivateEFormsPremium: boolean;
    ActivateAcademicHistory360: boolean;
    ActivateProgramAndService360: boolean;
    ActivateFeesAndBilling: boolean;
    EnableDataDefinitions: boolean;
    EnableCustomizationFramework: boolean;
    CombineGoalsAndObjectives: boolean;
    C360CustomFieldsImported: boolean;
    ForceTeachersDate: Date;
    UseSection504: boolean;
    EnableSelfRegistrationCode: boolean;
    ClassicIsGone: boolean;
    ViewDocumentBeforeApproval: boolean;
    AllowCopy: boolean;
    AllowCopyToCreateAmendedDocument: boolean;
    AllowCopyToCreateAnnualDocument: boolean;
    AllowSpEdAssessment: boolean;
    AllowCheckInOutSpEdForms: boolean;
    AllowCopyToCreateBothDocument: boolean;
    AllowPrintWithoutWorkingDraft: boolean;
    ShowParentInformation: boolean;
    ShowIEPInformation: boolean;
    ShowEvalInformation: boolean;
    ShowReferralInformation: boolean;
    ForceSDMADMINAudit: boolean;
    EnableMergeSectionsForAttendance: boolean;
    ActivateKendoGridInMasterSchedule360: boolean;
    EnableFreeReducedMealApp: boolean;
    EnableGoogleIdentityServices: boolean;
}
